import type { ArtFigure, Drawing } from '@sketchling/core';
import type { VignetteSpec } from './types';

/** The layers of a picture drawn over the painting: the object (`0:*`), its cast shadow and the overlay props. */
export function vignetteOverlay(drawing: Drawing, spec: VignetteSpec): ArtFigure | null {
  if (!drawing.art || !drawing.picture) return null;
  const keep = new Set(['bd:objCast', ...(spec.overlay ?? []).map((p) => `bd:${p}`)]);
  return { vb: drawing.art.vb, guides: [], layers: drawing.art.layers.filter((l) => (l.p ?? '').startsWith('0:') || keep.has(l.p ?? '')) };
}

